import { render } from "./PortfolioLandingPage.vue?vue&type=template&id=74ce16b0&scoped=true"
import script from "./PortfolioLandingPage.vue?vue&type=script&lang=js"
export * from "./PortfolioLandingPage.vue?vue&type=script&lang=js"

import "./PortfolioLandingPage.vue?vue&type=style&index=0&id=74ce16b0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ce16b0"]])

export default __exports__